import axios from 'axios';

export const getTechData = async (user) => {
  let a = []
  try {
    const { data } = await axios.get(process.env.REACT_APP_WEBGEOLOC_USER + user).then((res) => console.log(res));
    return data
  } catch (error) {
    console.log(error)
  }
}

export const getTechDataDate = async (user, startDate, endDate, idservice) => {
  try {


    const { data } = await axios.get(process.env.REACT_APP_WEBGEOLOC_USER_DATE + "?user=" + user + "&startDate=" + startDate + "&endDate=" + endDate).then((response) => {
      if (response.status === 200) {
        if (response.data.error === "invalid_request" && response.data.error_description === "The token expired.") {
          window.location.replace(process.env.REACT_APP_WEB_WEBGEOLOC_Manager + idservice);
        } else if (response.data.error_description === "Cannot get data") {
          return alert("Merci de choisir une autre date pour ce technicien...");
        } else {
          return response
        }
      }
    }).catch((error) => {
      if (error.response.status === 403) window.location.replace(process.env.REACT_APP_WEBGEOLOC_ERROR);
    });
    return data;
  } catch (error) {
    console.log(error)
  }
}

export const getAllUser = async (startDate, endDate, idservice) => {
  try {
    const { data } = await axios.get(process.env.REACT_APP_WEBGEOLOC_USERS + "?startDate=" + startDate + "&endDate=" + endDate)
      .then((response) => {

        if (response.status === 200) {

          if (response.data.error === "invalid_request" && response.data.error_description === "The token expired.") {
            window.location.replace(process.env.REACT_APP_WEB_WEBGEOLOC_Manager + idservice)
          } else if (response.data.length === 0) {
            return alert("Vous n'avez pas de techniciens pour cette periode, merci de choisir une autre date")
          }
        }
        return response;
      });

    return data;
  } catch (error) {
    if (error.response.status === 403) window.location.replace(process.env.REACT_APP_WEBGEOLOC_ERROR);

  }
}

export const getloc = async (folder) => {
  const { data } = await axios.get(process.env.REACT_APP_WEB_WEBGEOLOC_LOC+folder)
    .then((response) => {
      return response;
    });
  return data;
}
